import { AspenProvidersService, PaginatedDTO_ProviderDTO_, ProviderCreateDTO, ProviderDTO } from '../client'
import { usePaginatedData } from './usePaginatedData'

export const useProviders = (initialPage = 1, initialLimit = 10, initialSort = 'name:asc', initialFilters = {}) => {
    return usePaginatedData<PaginatedDTO_ProviderDTO_, ProviderCreateDTO, ProviderDTO>(
        AspenProvidersService.indexProvidersGet,
        initialPage,
        initialLimit,
        initialSort,
        initialFilters,
        AspenProvidersService.createProvidersPost
    )
}
